// extracted by mini-css-extract-plugin
export default {"gravityLeftNavigation":"cYDfTTa6QszNYBc5ECJv"};